import { NumericFormat } from "react-number-format";
import { FallBackImage } from "../default/fallback-image";
import { format } from 'date-fns';
import { useForm } from "react-hook-form";
import InputMask from 'react-input-mask';
import { useEffect, useState } from "react";
import { fetchPostEmailSendPurpose } from "../../../services/api";
import { useReCaptcha } from "next-recaptcha-v3";
import StickyBox from "react-sticky-box";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, FreeMode, Navigation } from "swiper";
import Image from "next/image";

export default function CarDetails({ ad, company }) {
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '', isSuccess: false });
    const [index, setIndex] = useState(-1);
    const [openYoutubeVideo, setOpenYoutubeVideo] = useState(false);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const onSubmit = async data => {
        const token = await executeRecaptcha("proposalSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendPurpose({
            cellPhone: data.txtCellPhone,
            email: data.txtEmail,
            message: data.txtMessage,
            name: data.txtName,
            idAd: ad.id,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtName', '');
                    setValue('txtEmail', '');
                    setValue('txtCellPhone', '');
                    setValue('txtMessage', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }

    return (
        <>
            <section className="inventory-details-area ptb-40">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="inventory-details">
                                <div className="product_details p-4 bg-white rounded">
                                    <div className="car-info">
                                        <div className="car-info-width">
                                            <span className="btn-meta bg-primary text-white">{`${ad.category} - ${ad.condition.replace('-', '')}`}</span>
                                            <h3 className="mt-2">{`${ad.brand} ${ad.model} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''}`}</h3>
                                            <div className="iv-meta">
                                                <span><i className="fa-solid fa-clock"></i>anunciado em: {format(new Date(ad.datetime), 'dd/MM/yyyy')}</span>
                                            </div>
                                        </div>
                                        <div className="car-info-details">
                                            <div className="sub-price">
                                                <h3 className="text-white" style={{ margin: "0" }}>
                                                    {
                                                        ad.promotionalPrice
                                                            ?
                                                            ad.price ?
                                                                <NumericFormat
                                                                    style={{ color: 'white', fontSize: '14px', textDecoration: 'line-through' }}
                                                                    value={ad.price ?? 0}
                                                                    displayType={'text'}
                                                                    thousandSeparator="."
                                                                    decimalSeparator=","
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    prefix='De R$ ' />
                                                                : 'consulte-nos'
                                                            : null
                                                    }
                                                    <p style={{ margin: "0" }}>
                                                        {
                                                            ad.price ?
                                                                <NumericFormat
                                                                    style={{ color: '#fff' }}
                                                                    value={ad.promotionalPrice ? ad.promotionalPrice : ad.price}
                                                                    displayType={'text'}
                                                                    thousandSeparator="."
                                                                    decimalSeparator=","
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    prefix={`${ad.promotionalPrice ? 'Por R$ ' : 'R$ '}`} />
                                                                : 'consulte-nos'
                                                        } </p>
                                                </h3>
                                            </div>
                                            <div className="sub-price">
                                                <span className="text-white">
                                                    <i className="fa-solid fa-gauge-high m-2"></i>
                                                    <NumericFormat
                                                        value={ad.mileage ?? 0}
                                                        displayType={'text'}
                                                        thousandSeparator={'.'}
                                                        decimalSeparator={','}
                                                        suffix=' km' />
                                                </span>
                                                <span className="text-white"><i className="fa-solid fa-eye m-2"></i>{`${company.city} - ${company.federativeUnit}`}</span>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-12 whatsapp-box">
                                        <button className="whatsapp-details"
                                            onClick={() => {
                                                const message = `Olá gostaria de mais informações sobre o veículo ${ad.brand} ${ad.model} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''} - ${ad.yearModel}`;
                                                window.open(`https://api.whatsapp.com/send?phone=+55${company.whatsapp}&text=${company.whatsappDetailsMessage ? company.whatsappDetailsMessage : message} - ${window.location.href}`);
                                            }}>
                                            <i className="fab fa-whatsapp"></i>
                                            <div className="flex-column align-items-start">
                                                <h5 className="mb-0">Fale com um Especialista</h5>
                                                <p className="mb-0">Tire suas dúvidas sobre este veículo</p>
                                            </div>
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </button>
                                        {/* <button
                                            type="button"
                                            className="btn btn-primary-whatsapp btn-md mt-30"
                                            
                                            <span className="me-2"></span><i></i><span>WhatsApp</span>
                                        </button> */}
                                    </div>
                                    <div className="iv_double_slider mt-30">
                                        <div className="iv_thumb_slider swiper">
                                            {
                                                ad.videos.length > 0
                                                    ? <div className="watch-video-button">
                                                        <a id="video-popup-btn" onClick={() => setOpenYoutubeVideo(true)} href='#' title={`${ad.brand} ${ad.model} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''}`}><i className="fas fa-play-circle watch-video-button-i"></i></a>
                                                    </div>
                                                    : null
                                            }
                                            <Swiper
                                                slidesPerView={1}
                                                navigation={true}
                                                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                                                modules={[Thumbs, Navigation, FreeMode]}
                                            >
                                                {
                                                    ad.photos.length > 0
                                                        ? ad.photos.map((photo, index) =>
                                                            <SwiperSlide key={index} className="swiper-slide thumb-wrapper rounded overflow-hidden thumb">
                                                                <a onClick={() => setIndex(index)}>
                                                                    <Image
                                                                        src={photo}
                                                                        alt="carro"
                                                                        width={808}
                                                                        height={490}
                                                                        sizes="100vw"
                                                                        style={{
                                                                            width: '100%',
                                                                            objectFit: 'cover'
                                                                        }} />
                                                                </a>
                                                            </SwiperSlide>
                                                        )
                                                        : <div className="swiper-slide thumb-wrapper rounded overflow-hidden">
                                                            <Image
                                                                src={'/img/no-image.jpeg'}
                                                                alt="carro"
                                                                width={808}
                                                                height={490}
                                                                sizes="100vw"
                                                                style={{
                                                                    width: '100%',
                                                                    height: 'auto',
                                                                }} />
                                                        </div>
                                                }
                                            </Swiper>
                                        </div>
                                        <div className="iv_thumb_control_slider swiper mt-3 mt-lg-4">
                                            <Swiper
                                                onSwiper={setThumbsSwiper}
                                                spaceBetween={24}
                                                slidesPerView={4}
                                                freeMode={true}
                                                watchSlidesProgress={true}
                                                breakpoints={{
                                                    [0]: {
                                                        slidesPerView: 4,
                                                        spaceBetween: 16
                                                    },
                                                    [992]: {
                                                        slidesPerView: 5,
                                                        spaceBetween: 24
                                                    }
                                                }}
                                                modules={[Thumbs, Navigation, FreeMode]}
                                            >
                                            </Swiper>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-12 d-flex p-4 mt-30 bg-white display-car-characteristics">
                                    <div className={`${ad.description ? 'col-lg-6' : 'col-lg-12'} border-right p-3`}>
                                        <h4 className="mb-5" style={{ textAlign: "center" }}>CARACTERÍSTICAS</h4>
                                        <div className="d-flex justify-content-center">
                                            <div className="car-characteristics">
                                                <div className="characteristic">
                                                    <div className="iv_info_item d-flex justify-content-center">
                                                        <div className="characteristics">
                                                            <i className="fa fa-car"></i>
                                                        </div>
                                                        <div className="info_content">
                                                            <span className="meta">Tipo</span>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <i className="fa-solid fa-arrow-right" style={{ color: "red" }}></i> <span className="title ">{ad.condition}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="characteristic">
                                                    <div className="iv_info_item d-flex justify-content-center">
                                                        <div className="characteristics">
                                                            <i className="fa fa-gauge"></i>
                                                        </div>
                                                        <div className="info_content">
                                                            <span className="meta">Quilometragem</span>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <i className="fa-solid fa-arrow-right" style={{ color: "red" }}></i> <span className="title ">
                                                                    <NumericFormat
                                                                        value={ad.mileage ?? 0}
                                                                        displayType={'text'}
                                                                        thousandSeparator={'.'}
                                                                        decimalSeparator={','}
                                                                    />
                                                                    km</span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="characteristic">
                                                    <div className="iv_info_item d-flex justify-content-center">
                                                        <div className="characteristics">
                                                            <i className="fa fa-gears"></i>
                                                        </div>
                                                        <div className="info_content">
                                                            <span className="meta">Câmbio</span>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <i className="fa-solid fa-arrow-right" style={{ color: "red" }}></i> <span className="title ">{ad.transmission}</span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="characteristic">
                                                    <div className="iv_info_item d-flex justify-content-center">
                                                        <div className="characteristics">
                                                            <i className="fa fa-palette"></i>
                                                        </div>
                                                        <div className="info_content">
                                                            <span className="meta">Cor</span>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <i className="fa-solid fa-arrow-right" style={{ color: "red" }}></i> <span className="title ">{ad.color}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="characteristic">
                                                    <div className="iv_info_item d-flex justify-content-center">
                                                        <div className="characteristics">
                                                            <i className="fa fa-calendar"></i>
                                                        </div>
                                                        <div className="info_content">
                                                            <span className="meta">Ano</span>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <i className="fa-solid fa-arrow-right" style={{ color: "red" }}></i><span className="title ">{`${ad.yearFabrication}/${ad.yearModel}`}</span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="characteristic">
                                                    <div className="iv_info_item d-flex justify-content-center">
                                                        <div className="characteristics">
                                                            <i className="fa fa-gas-pump"></i>
                                                        </div>
                                                        <div className="info_content">
                                                            <span className="meta">Combustível</span>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <i className="fa-solid fa-arrow-right" style={{ color: "red" }}></i> <span className="title ">{ad.fuel}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="characteristic">
                                                    <div className="iv_info_item d-flex justify-content-center">
                                                        <div className="characteristics">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="22"
                                                                height="22"
                                                                viewBox="0 0 200 200"
                                                                fill="currentColor"
                                                            >
                                                                <g transform="translate(0,200) scale(0.1,-0.1)">
                                                                    <path d="M765 1851 c-16 -10 -161 -148 -321 -307 -248 -246 -293 -295 -303
                                                            -330 -7 -28 -11 -211 -11 -573 l0 -531 905 0 905 0 0 880 0 880 -572 0 c-540
                                                            0 -575 -1 -603 -19z m1025 -441 l0 -320 -725 0 c-799 0 -785 -1 -785 58 0 15
                                                            4 32 8 37 4 6 129 130 278 278 l270 267 477 0 477 0 0 -320z m-49 -580 c23
                                                            -13 25 -43 3 -64 -12 -13 -38 -16 -120 -16 -58 0 -113 4 -123 10 -28 14 -34
                                                            40 -15 61 15 16 33 19 126 19 60 0 118 -5 129 -10z"/>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div className="info_content">
                                                            <span className="meta">Portas</span>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <i className="fa-solid fa-arrow-right" style={{ color: "red" }}></i> <span className="title ">{ad.doors}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="characteristic">
                                                    <div className="iv_info_item d-flex justify-content-center">
                                                        <div className="characteristics">
                                                            <i className="fa fa-shield"></i>
                                                        </div>
                                                        <div className="">
                                                            <span className="meta">Blindado</span>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <i className="fa-solid fa-arrow-right" style={{ color: "red" }}></i>  <span className="title ">{ad.armored ? 'Sim' : 'Não'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className={`${ad.description ? 'col-lg-6' : 'd-none'} border-left p-3`}>
                                        <h4 className="mb-5" style={{ textAlign: "center" }}>SOBRE O VEÍCULO</h4>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <p style={{ textAlign: 'justify', color: "#000000" }}>{ad.description}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className={`${ad.optionals.length > 0 ? '' : 'd-none'} product_info bg-white rounded p-4 mt-30`}>

                                    <h4 className="mb-30" style={{ textAlign: "center" }}>OPCIONAIS / ITENS DE SÉRIE</h4>
                                    <div className="row">
                                        {
                                            ad.optionals.map((optional, index) =>
                                                <div className="col-lg-4 d-flex justify-content-center" key={index}>
                                                    <ul className="iv_ft_list">
                                                        <li><span className="s"><i className="fa-solid fa-check" style={{ color: "#0B45CB" }}></i></span>{optional}</li>
                                                    </ul>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12">
                            <StickyBox offsetTop={140} offsetBottom={20}>
                                <div className="iv_sidebar mt-5 mt-xl-0">

                                    <div className="iv_sidebar_widget iv_seller_widget p-4 bg-white rounded mt-4">
                                        <h4 className="mb-30">Envie uma proposta</h4>
                                        <form onSubmit={handleSubmit(onSubmit)} className='seller_offer_form'>
                                            <div className="row g-2">
                                                <div className="col-8">
                                                    <div className="input-field">
                                                        <label>Nome</label>
                                                        <input type="text" {...register("txtName", { required: true })} required={errors.txtName} />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="input-field">
                                                        <label>Celular</label>
                                                        <InputMask type={'tel'} mask="(99) 99999-9999" maskChar=" " {...register("txtCellPhone", { required: true })} required={errors.txtCellPhone} />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-field">
                                                        <label>Email</label>
                                                        <input type="email" {...register("txtEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtEmail} />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-field">
                                                        <label>Mensagem</label>
                                                        <textarea
                                                            {...register("txtMessage", { required: true })}
                                                            required={errors.txtMessage}
                                                            defaultValue={`Olá gostaria de mais informações sobre o veículo ${ad.brand} ${ad.model} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''} - ${ad.yearModel}`}>
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                formPost.isError
                                                    ? <div className="row mt-4">
                                                        <div className="col-12">
                                                            <div className="error-badge bg-primary-light rounded d-block">{formPost.errorText}</div>
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                            {
                                                formPost.isSuccess
                                                    ? <div className="row mt-4">
                                                        <div className="col-12">
                                                            <div className="success-badge bg-primary-success rounded d-block">Proposta enviada com sucesso!</div>
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                            <div className="widget_meta col-lg-12 d-flex justify-content-center d-column gap-4">
                                                <button
                                                    type="submit"
                                                    disabled={formPost.isLoading}
                                                    className="btn-primary-contact btn-md mt-30"><i></i><span>Enviar Proposta</span>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </StickyBox>
                        </div>
                    </div>
                </div>
            </section>
            <Lightbox
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                slides={ad.photos.map(item => ({ src: item }))}
                plugins={[Fullscreen, Thumbnails, Zoom]} />
            <Lightbox
                open={openYoutubeVideo}
                close={() => setOpenYoutubeVideo(false)}
                slides={[{ type: "youtube", src: ad.videos[0] }]}
                render={{
                    slide: ({ type, src }) =>
                        type === "youtube" ? (
                            <iframe
                                style={{ width: '100%', height: '100%' }}
                                src={src}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        ) : null
                }}
            />
        </>
    )
}